$(() => {
    const $homeIndustryHeader = $('[data-selector="home-industry-header"]');
    const $homeIndustryContent = $('[data-selector="home-industry-content"]');
    const $homeIndustryBox = $('[data-selector="home-industry-box"]');
    const homeIndustryNum = $homeIndustryHeader.children().length;
    const autoSwitchIntervalTime = 3000; // 自动切换频率
    let autoSwitchIntervalKey;
    let activeIndex = 1; // 当前项

    const stopAutoSwitch = () => {
        autoSwitchIntervalKey && clearInterval(autoSwitchIntervalKey);
    }
    const startAutoSwitch = () => {
        stopAutoSwitch();
        autoSwitchIntervalKey = setInterval(() => {
            // 切换行业header
            $homeIndustryHeader.children().removeClass('header-title-item-active');
            $($homeIndustryHeader.children()[activeIndex]).addClass('header-title-item-active');
            // 切换行业内容
            $homeIndustryContent.children().hide();
            $($homeIndustryContent.children()[activeIndex]).show();
            activeIndex = activeIndex + 1 > homeIndustryNum - 1 ? 0 : activeIndex + 1;
        }, autoSwitchIntervalTime)
    }
    // 自动切换
    startAutoSwitch();
    // 鼠标悬浮内容区时停止切换
    $homeIndustryBox.on('mouseenter', () => {
        stopAutoSwitch();
    })
    // 鼠标离开内容区时开始切换
    $homeIndustryBox.on('mouseleave', () => {
        startAutoSwitch();
    })
    // 手动切换
    $homeIndustryHeader.children().on('mouseenter', function callback() {
        const currentTarget = $(this)[0];
        const industryType = currentTarget.dataset.type;
        // 切换行业header
        $homeIndustryHeader.children().removeClass('header-title-item-active')
        $(currentTarget).addClass('header-title-item-active');
        // 切换行业内容
        $homeIndustryContent.children().hide();
        const $industryContent = $(`[data-selector="${industryType}"]`);
        $industryContent.show();
        activeIndex = $homeIndustryHeader.children().index($(this));
    });


});
